/** @jsx jsx */
import { css, jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { MultiPropertyCheckboxSelector } from 'components/selectors/multiPropertyCheckboxSelector';
import { Tab, Tabs } from '@blueprintjs/core';

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param chartConfiguration
 * @param updateConfiguration
 * @returns {*}
 * @constructor
 */

export const TableWidgetKnobs = ({
	cardIndex,
	endpointQuery,
	flags
}) => {
	return (
		<Tabs>
			<Tab id='data' title='Data' panel={
				<React.Fragment>
					<MultiPropertyCheckboxSelector
						label={'Select Column Headers'}
						cardIndex={cardIndex}
						propertyName={'columns'}
						endpointQuery={endpointQuery}
						flags={flags}
					/>
				</React.Fragment>} />
		</Tabs>
	);
};

//If we use css={<>} it wipes out Tab(s) own classes. But Tab(s) don't pass thru styles prop.
//Suggested fix is something like this: https://github.com/emotion-js/emotion/issues/1196#issuecomment-475047419
// (spoiler alert, its ugly)
const tabsCss = css`
	max-height: 100%;
	display: flex;
	flex-direction: column;
`;

const tabCss = css`
	display: flex;
	flex-direction: column;
	overflow: hidden;
`;
